export default __webpack_public_path__ + "video-b9aa771.png";